module.exports = __webpack_public_path__ + "static/media/sulogoaquiintro.4663be27.svg";